export const capitalizeFirstLetter = (targetStr: any) => {
  return targetStr ? targetStr.charAt(0).toUpperCase() + targetStr.slice(1) : '';
};
